module.exports = __webpack_public_path__ + "img/success-with-woodpacking-bosspack.75ddf377.svg";